var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 515075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "url(#paint0_linear_1088_11796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38 20L20 32L2 20L20 8L38 20Z",
    fill: "url(#paint1_linear_1088_11796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27 20C27 23.867 23.867 27 20 27C16.133 27 13 23.867 13 20C13 16.133 16.133 13 20 13C23.867 13 27 16.133 27 20Z",
    fill: "url(#paint2_linear_1088_11796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.8054 16.746C13.4654 17.391 13.2314 18.094 13.1064 18.836C15.3604 18.559 21.4854 18.273 26.6414 22.211C26.8714 21.516 27.0004 20.773 27.0004 20C27.0004 20 27.0004 19.996 27.0004 19.992C22.0594 16.645 16.6564 16.512 13.8054 16.746Z",
    fill: "#F0F4F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1088_11796",
    x1: 7.128,
    y1: 7.128,
    x2: 35.412,
    y2: 35.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AD64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1088_11796",
    x1: 2,
    y1: 20,
    x2: 38,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1088_11796",
    x1: 14.521,
    y1: 14.521,
    x2: 24.422,
    y2: 24.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D61A9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrFlag);
export default __webpack_public_path__ + "static/media/brFlag.ce76f6aefc724f41ab3dd59580f962ee.svg";
export { ForwardRef as ReactComponent };